import React, { FC, useMemo } from 'react';
import _sortBy from 'lodash/sortBy';
import { useLazyQuery } from '@apollo/client';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import { SEEKING_REPRESENTATIONS_QUERY } from '../FilterBasicCollectionGraphQL';

export type SeekingRepresentationProps = {
  label: string;
  name: string;
  className?: string;
};

const SeekingRepresentation: FC<SeekingRepresentationProps> = ({ label, name, className }) => {
  const [fetchRepresentations, results] = useLazyQuery(SEEKING_REPRESENTATIONS_QUERY);

  // Filter and sort the seeking representation options:
  const options = useMemo(() => {
    if (results?.data?.seekingRepresentations) {
      const filteredItems = results.data.seekingRepresentations.reduce((acc, representation) => {
        if (representation.enabled) {
          acc.push({ label: representation.name, value: representation.id });
        }

        return acc;
      }, []);

      return _sortBy(filteredItems, 'sortOrder');
    }

    return [];
  }, [results?.data?.seekingRepresentations]);

  return (
    <DropdownWithChildren
      isMultipleSelect
      withFormik
      withSelectAll
      name={name}
      toggleLabel={label}
      options={options}
      isLoading={results.loading}
      onOptionsFetch={() => fetchRepresentations()}
      className={className}
    />
  );
};

export default SeekingRepresentation;
